export const API_ERROR_RESPONSE = 'response-error'
